import React, { useState, useEffect, useContext } from "react";
import {
    makeStyles,
    createStyles,
    useTheme,
} from "@material-ui/core/styles";
import './LayoutScss/LayoutScss.scss';
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Drawer from "@material-ui/core/Drawer";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import clsx from "clsx";
import { ExtraDataContext } from "../Context/ExtraDataContext";
import LoadingSuspense from "../ShearCompo/LoadingSuspense";
import { renderRoutes } from "react-router-config";
import AppContext from "../Context/AppContext";
import SideNavLayout from "./SideNavLayout";
import { Icon } from "@material-ui/core";


const MainLayout = () => {
    const { isDarkTheme } = useContext(ExtraDataContext);

    const { rootRouting } = useContext(AppContext);
    const drawerWidth = 280;
    const useStyles = makeStyles((theme) =>
        createStyles({
            root: {
                display: "flex",
            },
            appBar: {
                transition: theme.transitions.create(["margin", "width"], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
            appBarShift: {
                width: `calc(100% - ${drawerWidth}px)`,
                marginLeft: drawerWidth,
                transition: theme.transitions.create(["margin", "width"], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
            menuButton: {
                marginRight: theme.spacing(2),
            },
            hide: {
                display: "none",
            },
            drawer: {
                flexShrink: 0,
            },
            drawerHide: {
                width: 0,
            },
            drawerPaper: {
                width: drawerWidth,
                backgroundColor: `${isDarkTheme === false ? '#fff' : '#121212'}`,
                color: `${isDarkTheme === true ? '#AAAAAA' : 'rgb(19, 17, 17)'}`
            },
            drawerHeader: {
                display: "flex",
                alignItems: "center",
                padding: theme.spacing(0, 1),
                // necessary for content to be below app bar
                ...theme.mixins.toolbar,
                justifyContent: "flex-end",
            },
            content: {
                flexGrow: 1,
                padding: theme.spacing(3),
                transition: theme.transitions.create("margin", {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
            contentShift: {
                transition: theme.transitions.create("margin", {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginLeft: drawerWidth,
            },
        })
    );
    const classes = useStyles();

    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const [isSidebarOpen, setSidebarOpen] = useState(!smallScreen);

    useEffect(() => {
        setSidebarOpen(!smallScreen);
    }, [smallScreen]);

    function handleToggleSidebar(open) {
        setSidebarOpen(open);
    }

    return (
        <div className={classes.root}>

            <Drawer
                id="sideNavDrawer"
                className={clsx(classes.drawer, {
                    [classes.drawerHide]: !isSidebarOpen,
                })}
                variant="persistent"
                anchor="left"
                open={isSidebarOpen}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={`my-4 ${classes.drawerHeader}`} >
                    <div className="NavLogoParent w-100 text-center">
                        {isDarkTheme ?
                            <img src="https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/shopkpr-personal/logo/logo_2.svg" alt="" />
                            :
                            <img src="https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/shopkpr-personal/logo/logo_1.svg" alt="" />
                        }
                    </div>
                    <IconButton onClick={() => handleToggleSidebar(false)}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <SideNavLayout />
                <div className="px-3 py-3">
                    <button className="btn DEFAULT_COLOR d-flex align-items-center">
                        <Icon>logout</Icon>
                        <span> Logout</span>
                    </button>
                </div>
            </Drawer>
            <main
                className={`p-0 w-100 ${clsx(classes.content, {
                    [classes.contentShift]: isSidebarOpen && !smallScreen,
                })}`}
            >
                <div className="drawerOpenBtn position-absolute">
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => handleToggleSidebar(true)}
                        edge="start"
                        className={clsx(classes.menuButton, isSidebarOpen && classes.hide)}
                    >
                        <MenuIcon className={`rounded ${isDarkTheme ? 'MAIN_BG_DARK_GREEN' : 'bg-white'}`} />
                    </IconButton>
                </div>
                <LoadingSuspense>
                    {renderRoutes(rootRouting)}
                </LoadingSuspense>
            </main>
        </div>
    );
}

export default MainLayout;